import { render, staticRenderFns } from "./containers.vue?vue&type=template&id=2a16f174&"
import script from "./containers.vue?vue&type=script&lang=js&"
export * from "./containers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports